import map from 'lodash/fp/map';
import trim from 'lodash/trim';

/* global jQuery, document */
(($, Drupal) => {

  'use strict';

  Drupal.behaviors.cidrap_theme_views = {
    attach: (context, settings) => {
      window.once('cidrap-theme-views', document.body).forEach(() => {
        if (document.querySelector('.view-resources')) {
          // Generate buttons for each of the active filters in the resources view.
          const updateFilters = () => {
            let view = document.querySelector('.view-resources');
            const filters = view.querySelector('.view-filters');
            const active = view.querySelector('.view-active-filters');
            const submit = view.querySelector('.form-actions [type="submit"]');
            active.innerHTML = '';
            if (filters) {
              // map((radio) => {
              //   radio.addEventListener('click', () => {
              //     submit.click();
              //   });
              // }, filters.querySelectorAll('[name="year"]'));
              // map((radio) => {
              //   radio.addEventListener('click', () => {
              //     submit.click();
              //   });
              // }, filters.querySelectorAll('[name="year"]'));
              const generateCheckboxUnset = (checkbox) => {
                const label = filters.querySelector(`label[for="${checkbox.id}"]`);
                const textLabel = trim(label.innerHTML);
                const button = document.createElement('button');
                button.innerHTML = textLabel;
                button.classList.add('active-filter-btn');
                button.addEventListener('click', () => {
                  label.click();
                  submit.click();
                });
                active.appendChild(button);
              };
              // Filter unsets for topic
              map((checkbox) => {
                generateCheckboxUnset(checkbox);
              }, filters.querySelectorAll('#resources-filter-topic [type="checkbox"]:checked'));
              // Filter unsets for type 'type'
              map((checkbox) => {
                generateCheckboxUnset(checkbox);
              }, filters.querySelectorAll('#resources-filter-type [type="checkbox"]:checked'));
              map((checkbox) => {
                generateCheckboxUnset(checkbox);
              }, filters.querySelectorAll('#resources-filter-year [type="checkbox"]:checked'));

              const generateAutocompleteUnset = (autocomplete) => {
                if (autocomplete.value !== '') {
                  const button = document.createElement('button');
                  button.innerHTML = autocomplete.value;
                  button.classList.add('active-filter-btn');
                  button.addEventListener('click', () => {
                    autocomplete.value = '';
                    submit.click();
                  });
                  active.appendChild(button);
                }
              }
              // MOVE THIS TO AFTER Ajax loads to then check so we don't watch on keyup - add class
              map((autocomplete) => {
                // input.addEventListener('keyup', () => {
                //   submit.click();
                // });
                generateAutocompleteUnset(autocomplete);
              }, filters.querySelectorAll('.form-item-author input'));

              // If the autocomplete input has a value we need to append a button to unset it.
              // const autocomplete = document.querySelector('.form-item-author input');
              
              // Filter unsets for year
              // map((checkbox) => {
              //   const label = filters.querySelector(`label[for="${checkbox.id}"]`);
              //   const textLabel = trim(label.innerHTML);
              //   if (textLabel !== 'All') {
              //     const button = document.createElement('button');
              //     button.innerHTML = textLabel;
              //     button.classList.add('active-filter-btn');
              //     button.addEventListener('click', () => {
              //       filters.querySelector('#resources-filter-year [type="checkbox"]').click();
              //       submit.click();
              //     });
              //     active.appendChild(button);
              //   }
              // }, filters.querySelectorAll('#resources-filter-year [type="checkbox"]:checked'));
            }
          };

          // Remove reference IDs for autocomplete elements on init.
          // $('.form-item-author .form-autocomplete').once('replaceReferenceIdOnInit').each(function () {
          //   let splitValues = (this.value && this.value !== 'false') ?
          //     Drupal.autocomplete.splitValues(this.value) : [];

          //   if (splitValues.length > 0) {
          //     let labelValues = [];
          //     for (let i in splitValues) {
          //       let value = splitValues[i].trim();
          //       let entityIdMatch = value.match(/\s*\((.*?)\)$/);
          //       if (entityIdMatch) {
          //         labelValues[i] = value.replace(entityIdMatch[0], '');
          //       }
          //     }

          //     if (labelValues.length > 0) {
          //       $(this).data('real-value', splitValues.join(', '));
          //       this.value = labelValues.join(', ');
          //     }
          //   }
          // });

          let autocomplete = Drupal.autocomplete.options;
          autocomplete.originalValues = [];
          autocomplete.labelValues = [];

          // /**
          //  * Add custom select handler.
          //  */
          autocomplete.select = function (event, ui) {
            autocomplete.labelValues = Drupal.autocomplete.splitValues(event.target.value);
            autocomplete.labelValues.pop();
            autocomplete.originalValues.pop();
            autocomplete.labelValues.push(ui.item.label);
            autocomplete.originalValues.push(ui.item.value);

            $(event.target).data('real-value', autocomplete.labelValues.join(', '));
            event.target.value = autocomplete.originalValues.join(', ');
            // // add class to indicate that a value has been selected
            // Submit the form.
            document.querySelector('.view-resources .form-actions [type="submit"]').click();
            event.target.classList.add('value-selected');

            return false;
          }

          updateFilters();
          // $(document).ajaxComplete(updateFilters);
          // On ajaxComplete get the id of the ajax call completed
          // and if it's the resources view, update the filters, this prevents us from
          // getting the filters as the user types in the autocomplete box for authors.
          $(document).ajaxComplete(function (event, xhr, settings) {
            if (settings.extraData && settings.extraData.view_name === 'resources') {
              updateFilters();
            }
          });

        }
      });
    },
  };
})(jQuery, Drupal);